export default __webpack_public_path__ + "static/media/lfVWBmiW_400x400.114520ac.png";